import React, { useEffect, useState } from "react";
import EsqueletoCargando from "componentes/EsqueletoCargando";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarExport,
    esES,
} from "@mui/x-data-grid";

/**
 * sortModel es un json con el ordenamiento a efectuar. Ejemplo:
 * 
 *  sortModel = {
      field: 'username',
      sort: 'asc',
    },
    @nombreBtnCSV {String} Permite setear un nombre personalizado para el boton de Exportar
    @btnRenderPdf {ReactComponente} es un boton que renderiza un pdf
    @btnRenderExcel {ReactComponente} es un boton que renderiza un Excel (La lógica se hace afuera)
 */
function TablaMaterialUI({
    columnas,
    filas,
    cargando,
    sortModel = false,
    toolbar = false,
    nombreBtnCSV = "",
    btnRenderPdf = false,
    btnRenderExcel = false,
}) {
    const [pageSize, setPageSize] = React.useState(10);
    const [sortModelInterno, setSortModelInterno] = React.useState([sortModel]);

    const ordenamiento = () => {
        if (Boolean(sortModel)) {
            return {
                sortModel: sortModelInterno,
                onSortModelChange: (model) => setSortModelInterno(model),
            };
        }
        return {};
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport />
                {btnRenderPdf}
                {btnRenderExcel}
            </GridToolbarContainer>
        );
    }

    /* Esto permite agregar nuestras propias traducciones al objeto */
    const traducciones = () => {
        let traducciones = { ...esES.props.MuiDataGrid.localeText };
        if (Boolean(nombreBtnCSV)) {
            traducciones = { ...traducciones, toolbarExport: nombreBtnCSV };
        }
        return traducciones;
    };

    return (
        <DataGrid
            localeText={traducciones()}
            rows={filas}
            columns={columnas}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            pagination
            disableSelectionOnClick
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            components={{
                LoadingOverlay: EsqueletoCargando,
            }}
            loading={cargando}
            {...ordenamiento()}
            components={{
                Toolbar: toolbar ? CustomToolbar : null,
            }}
        />
    );
}

export default TablaMaterialUI;
